import React, { PropTypes } from 'react';
import moment from 'moment';
import '../../node_modules/moment/locale/fr';
import { capitalizeFirstLetter } from '../util/StringUtil';

function Date({ date, withoutDay }) {

  const clazz = withoutDay ? 'LL' : 'LLLL';

  const formattedDate = capitalizeFirstLetter(moment.unix(date).locale('fr').format(clazz));
  return (
    <span className="valign-center truncate">
      <i className="material-icons orange-color">query_builder</i>&nbsp;{formattedDate}
    </span>
  );
}

Date.propTypes = {
  date: PropTypes.number.isRequired,
  withoutDay: PropTypes.bool,
}

export default Date;



/** WEBPACK FOOTER **
 ** ./src/components/Date.js
 **/